// ↑ / ↓ (cards: ↑ ↓ ← →) move a highlight through a list; Enter opens, Space ticks (code list #8, round 13).
// Ignored while typing in a field, while a menu or dialog is open, or with Ctrl / Alt / ⌘.
import { useEffect } from "react";
import { isTyping } from "./esc";
import { moveGrid, moveIndex } from "./lists";

export function useListKeys({ count, hi, setHi, onEnter, onSpace, cols, active = true }: {
  count: number; hi: number | null; setHi: (i: number | null) => void;
  onEnter?: (i: number) => void; onSpace?: (i: number) => void; cols?: number; active?: boolean;
}): void {
  useEffect(() => {
    if (!active) return;
    const on = (e: KeyboardEvent) => {
      if (e.defaultPrevented || isTyping(e.target as Element) || e.altKey || e.ctrlKey || e.metaKey) return;
      if (document.querySelector(".pop-menu, .switcher-menu, .profile-menu, [role=dialog], [role=alertdialog]")) return;
      if (e.key === "Enter" && hi !== null && onEnter) { e.preventDefault(); onEnter(hi); return; }
      if (e.key === " " && hi !== null && onSpace) { e.preventDefault(); onSpace(hi); return; }
      const next = cols ? moveGrid(hi, count, cols, e.key) : moveIndex(hi, count, e.key);
      if (next !== hi) { e.preventDefault(); setHi(next); }
    };
    window.addEventListener("keydown", on);
    return () => window.removeEventListener("keydown", on);
  }, [count, hi, setHi, onEnter, onSpace, cols, active]);
  useEffect(() => { if (hi !== null) document.querySelector(`[data-row="${hi}"]`)?.scrollIntoView({ block: "nearest" }); }, [hi]);
}
